var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kai-card-piechart"},[_c('div',{attrs:{"id":"chart-wrap"}},[_c('apexcharts',{ref:"chart",attrs:{"id":"chart","width":_vm.cardWidth,"heigth":"auto","type":"pie","options":_vm.chartOptions,"series":_vm.series},on:{"click":_vm.onChartClickEvent,"mounted":_vm.onChartMountedEvent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }